    function detectDeviceType() {
    const userAgent = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /(iPad|Tablet|PlayBook|Kindle)|(android(?!.*mobile))/i.test(userAgent);

    if (isMobile) {
      return 'Mobile';
    } else if (isTablet) {
      return 'Tablet';
    } else {
      return 'Desktop';
    }
  }
  const deviceType = detectDeviceType();
  
  if(deviceType=="Desktop"){
    document.addEventListener('DOMContentLoaded', function() {
              // 获取目标元素
              const targetAreasb = document.getElementById('targetArea2');
              const targetArea = document.getElementsByClassName('m-app-section__content')[0];

              // 状态变量
              let hasReachedBottom = false; // 是否已经到达底部区域
              let hasLeftBottom = false; // 是否已经离开底部区域

              // 检查元素是否在视口中（只要有部分可见就算）
              function isElementInViewport(el) {
                  const rect = el.getBoundingClientRect();
                  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

                  // 只要元素有任何部分在视口中就算可见
                  return (
                      rect.top < windowHeight+600 &&
                      rect.bottom > 0 &&
                      rect.left < windowWidth &&
                      rect.right > 0
                  );
              }

              // 检查元素是否完全离开视口（向上滚动）
              function isElementCompletelyOutOfViewport(el) {
                  const rect = el.getBoundingClientRect();
                  return rect.bottom < 0;
              }

              // 滚动事件处理函数
              function handleScroll() {
                  // 检查目标区域是否在视口中
                  const isVisible = isElementInViewport(targetArea);
                  const isCompletelyOutOfView = isElementCompletelyOutOfViewport(targetArea);

                  const isVisiblesb = isElementInViewport(targetAreasb);
                  const isCompletelyOutOfViewsb = isElementCompletelyOutOfViewport(targetAreasb);

                  var scrollDistance = document.documentElement.scrollTop || document.body.scrollTop;
                 

                  // 更新状态
                  if (isVisible||isVisiblesb && !hasReachedBottom ) {
                      // 首次到达底部区域
                      hasReachedBottom = true;
                      console.log('已到达底部指定区域');
                      $(".floatViewCon").addClass("bottom");
                  }

                  if (hasReachedBottom && (!isVisible||!isVisiblesb) && !hasLeftBottom) {
                      // 离开底部区域（只要元素不可见就触发，不要求完全离开）
                      hasLeftBottom = true;
                      console.log('已离开底部指定区域');
                      $(".floatViewCon").removeClass("bottom");
                  }

                  if (isVisible||isVisiblesb && hasLeftBottom) {
                      // 如果再次回到底部区域（重复滚动）
                      hasLeftBottom = false;
                      console.log('再次到达底部指定区域');
                      $(".floatViewCon").addClass("bottom");
                  }

              }

              // 为窗口添加滚动事件监听
              window.addEventListener('scroll', handleScroll);

              // 初始检查
              handleScroll();
          });
          $(".prolearnmore").click(function(){
            $(".prolearnmore").hide();
            $(".npTitleText").removeClass("no16");
            $(".mainAllCon").removeClass("nomain");
            $("#mainId").removeClass("nomain");
            $("#fullId").removeClass("nomain");
            $("#comId").removeClass("nomain");
            $("#toTagImgBottom").removeClass("nomain");
            
          })
  }else{

    $("#infoId").find(".npTitleText").click(function(){
      var num=$(this).attr("data-num");
      if(num==1){
        $("#infoId").find(".npTitleText").find(".addIcon").text("-");
        $("#infoId").find(".mainAllCon").addClass("add");
        $(this).attr("data-num",2);
      }else{
        $("#infoId").find(".npTitleText").find(".addIcon").text("+");
        $("#infoId").find(".mainAllCon").removeClass("add");
        $(this).attr("data-num",1);
      }
    })



    $("#mainId").find(".npTitleText").click(function(){
      var num=$(this).attr("data-num");
      if(num==1){
        $("#mainId").find(".npTitleText").find(".addIcon").text("-");
        $("#mainId").find(".mainAllCon").addClass("add");
        $(this).attr("data-num",2);
      }else{
        $("#mainId").find(".npTitleText").find(".addIcon").text("+");
        $("#mainId").find(".mainAllCon").removeClass("add");
        $(this).attr("data-num",1);
      }
    })

    $("#fullId").find(".npTitleText").click(function(){
      var num=$(this).attr("data-num");
      if(num==1){
        $("#fullId").find(".npTitleText").find(".addIcon").text("-");
        $("#fullId").find(".mainAllCon").addClass("add");
        $(this).attr("data-num",2);
      }else{
        $("#fullId").find(".npTitleText").find(".addIcon").text("+");
        $("#fullId").find(".mainAllCon").removeClass("add");
        $(this).attr("data-num",1);
      }
    })



  }
